import { combineReducers } from 'redux';
import routing from './routing';
import auth from './auth';
import update from './update';

export const eaTravelRates = combineReducers({
    routing,
    auth,
    update,
});
